import axios from "axios";
import {getSelfToken} from '../../_helpers/auth/secureToken'
import {AlbumEndpoint} from '../_constants/api.constant'
export async function getReleaseAlbum(limit, offset) {
    const response = await axios.get(
        AlbumEndpoint.GETALLALBUMDATA,
        {   
            headers: {
                'Authorization': 'Token ' + getSelfToken(),
            },  
             params:{
                limit:limit,offset:offset
            }
        }
    ).then(function (response) {
        return response;
    }).catch(function (error) {
        return error.response;
    });
    return response
}